import styled from 'styled-components';
import { BorderRadius, Colors, ScreenWidth, Spacing } from 'web-common/src/shared/styles';

export const imageSizePx = 56;

export const Container = styled.div`
  @media (max-width: ${ScreenWidth.SMALL}) {
    margin-bottom: ${Spacing.THREE_QUARTERS};
  }
`;

export const ContentContainer = styled.div`
  width: 100%;
  overflow-x: hidden;
  flex-shrink: 0;
  background: ${Colors.BUTTER_400};
  padding: ${Spacing.SINGLE_HALF} 0 0 ${Spacing.SINGLE_HALF};

  @media (max-width: ${ScreenWidth.SMALL}) {
    padding: ${Spacing.SINGLE} 0 0 ${Spacing.SINGLE};
  }
`;

export const SuggestionsContainer = styled.div`
  overflow-x: scroll;
  scroll-padding-left: ${Spacing.SINGLE_HALF};
  scroll-snap-type: x mandatory;
  display: flex;
  align-items: center;
  margin-left: -${Spacing.SINGLE_HALF};
  margin-bottom: ${Spacing.QUARTER};
  padding-bottom: ${Spacing.SINGLE};

  @media (max-width: ${ScreenWidth.SMALL}) {
    padding-bottom: ${Spacing.THREE_QUARTERS};
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${Spacing.SINGLE};
`;

export const ScrollButtons = styled.div`
  display: flex;
  margin-right: ${Spacing.HALF};
`;

export const ScrollButton = styled.button`
  background: none;
  border: none;
  outline: none;
  color: ${Colors.ELDERBERRY};

  &:active,
  &:hover {
    color: ${Colors.ELDERBERRY_DARK_10};
  }

  &:disabled {
    color: ${Colors.ELDERBERRY_LITE_10};
  }
`;

export const SuggestionContainer = styled.div`
  margin-right: ${Spacing.HALF};
  border-radius: ${Spacing.HALF};
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  background: white;
  width: 300px;
  scroll-snap-align: start;

  &:first-child {
    margin-left: ${Spacing.SINGLE_HALF};
  }

  &:last-child {
    margin-right: ${Spacing.SINGLE_HALF};
  }

  @media (max-width: ${ScreenWidth.SMALL}) {
    &:last-child {
      margin-right: ${Spacing.SINGLE};
    }
  }
`;

export const LeftContainer = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  overflow: hidden;
  border: none;
  outline: none;
  padding: 0;
  background: transparent;
  text-align: left;
`;

export const RightContainer = styled.div`
  display: flex;
  flex-shrink: 0;
`;

export const SuggestionImageContainer = styled.div`
  position: relative;
  overflow: hidden;
  background: white;
  display: flex;
  width: ${imageSizePx}px;
  flex-shrink: 0;
  margin-right: ${Spacing.HALF};
  background: ${Colors.GRAY_LITE_30};
`;

export const TextContainer = styled.div`
  min-width: 0;

  p {
    cursor: pointer;
  }
`;

export const AddToCartButton = styled.button`
  width: ${Spacing.DOUBLE};
  height: ${Spacing.DOUBLE};
  padding: 0;
  margin: 0 ${Spacing.THREE_QUARTERS};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${Colors.RADISH};
  background: white;
  border: none;
  border-radius: ${BorderRadius.S};
  transition: all 100ms ease;
  outline: none;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: transparent;
    border-radius: 4px;
    box-shadow: 0px 0px 0px #ec2044;
    transition: all 100ms ease;
    border: 2px solid transparent;
  }

  &:hover {
    background: ${Colors.BELL_PEPPER_LITE_30};
  }

  &:focus&:not(&:active) {
    background: ${Colors.BELL_PEPPER_LITE_30};

    &:after {
      box-shadow: 0px 0px 4px #ec2044;
      border: 2px solid white;
    }
  }

  &:active {
    background: ${Colors.RADISH};
    color: white;
    outline: none;
  }
`;
